<template>
    <div class="modal-backdrop" @click="closeModal">
        <div class="modal-content" @click.stop>
            <div class="layout-center">
                <div class="wrapper w-100">
                    <div class="max-w-540 w-100">
                        <div id="payment-method" class="w-100"></div>
                        <div id="agreement" class="w-100"></div>
                        <div class="btn-wrapper w-100">
                            <button @click="requestPayment" class="btn primary w-100">{{ buttonName }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-console */

    import { accountApi } from '../../api/api';
    import { tossPayments, ANONYMOUS } from '@/components/specific/Payment/tosspayments';

    export default {
        name: "TossPayment",
        props: {
            paymentInfo: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        orderName: "",
                        payerName: null,
                        payerEmail: null,
                        amount: {
                            currency: "KRW",
                            value: 0,
                        },
                        memo: null,
                    }
                },
            },
        },
        data() {
            return {
                buttonName: "결제하기",
                widgets: null,
                memberIdx: 1, // 로그인 기능 생기면 수정
            }
        },
        methods: {
            async renderUI() {
                this.widgets = tossPayments.widgets({
                    customerKey: ANONYMOUS,
                });

                await this.widgets.setAmount(this.paymentInfo.amount);

                // 결제 수단과 약관 UI 렌더링
                await Promise.all([
                    this.widgets.renderPaymentMethods({
                        selector: "#payment-method",
                        variantKey: "DEFAULT",
                    }),
                    this.widgets.renderAgreement({
                        selector: "#agreement",
                        variantKey: "AGREEMENT",
                    }),
                ]);
            },
            async requestPayment() {
                try {
                    const orderId = this.generateRandomString();
                    this.requestCreateOrder(orderId);

                    response = await this.widgets.requestPayment({
                        orderId: orderId,
                        orderName: this.paymentInfo.orderName,
                        successUrl: `${window.location.origin}/payments/toss/success`,
                        failUrl: `${window.location.origin}/payments/toss/fail`,
                        customerEmail: this.payerEmail,
                        customerName: this.paymentInfo.payerName,
                    });
                } catch (err) {
                    // console.log("결제 요청을 실패했습니다.");
                }
            },
            generateRandomString() {
                return window.btoa(Math.random()).slice(0, 20);
            },
            requestCreateOrder(orderId) {
                const body = {
                    order_id: orderId,
                    payer_name: this.paymentInfo.payerName,
                    payer_email: this.paymentInfo.payerEmail,
                    amount: this.paymentInfo.amount.value,
                    name: this.paymentInfo.orderName,
                    currency_code: this.paymentInfo.amount.currency,
                }

                accountApi.createTosspaymentsOrder(body);
            },
            closeModal() {
                this.$emit("close");
            },
        },
        mounted() {
            this.renderUI();
        }
    }
</script>

<style scoped>
    /* ****************** background ****************** */

    .w-100 {
        width: 100%;
    }

    .h-100 {
        height: 100%;
    }

    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px;
        overflow: auto;
    }

    .max-w-540 {
        max-width: 540px;
    }

    /* ****************** button ****************** */

    .btn-wrapper {
        padding: 0 24px;
    }

    .btn {
        padding: 11px 22px;
        border: none;
        border-radius: 8px;

        background-color: #f2f4f6;
        color: #4e5968;
        font-weight: 600;
        font-size: 17px;
        cursor: pointer;
    }

    .btn.primary {
        background-color: #3282f6;
        color: #f9fcff;
    }

    /* ****************** modal ****************** */

    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .modal-content {
        background-color: white;
        border-radius: 8px;
        min-width: 60%;
        max-width: 70%;
        min-height: 60%;
        max-height: 70%;
        overflow-y: hidden;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }

    .layout-center {
        display: flex;
        justify-content: center;
        align-items: center;
        height: auto;
    }
</style>